import * as constants from './constants';
import { LoginAction } from './action';

export interface ILoginState {
  loggedIn: boolean,
  errors: object
}

export const initialState: ILoginState = {
  loggedIn: false,
  errors: {}
}

export const reducer = (state: ILoginState = initialState, action: LoginAction): ILoginState => {
  switch(action.type) {
    case constants.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: !!action.payload,
        errors: {}
      }
    case constants.LOGIN_FAILURE:
      return {
        ...state,
        loggedIn: false,
        errors: {
          login: action.payload
        }
      }
    case constants.LOGOUT_SUCCESS:
      return {
        ...state,
        loggedIn: false,
        errors: {},
      }
    /* istanbul ignore next */
    default:
      return {
        ...state
      }
  }
}


// WEBPACK FOOTER //
// ./src/modules/login/reducer.ts